module.exports = __webpack_public_path__ + "static/media/revolution.2feabbdb.jpg";